import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Coming late, but it is worth the wait...`}</p>
    <h1>{`What's LSP`}</h1>
    <p>{`Please see my old `}<a parentName="p" {...{
        "href": "../2018-11-05-language-server-protocol"
      }}>{`post`}</a>{`. Now LSP client is integrated in neovim to bring fast/smooth user experience!`}</p>
    <h1>{`What About LanguageClient-Neovim in That Post?`}</h1>
    <p>{`It's way hard to config and this one is no better than `}<a parentName="p" {...{
        "href": "https://github.com/neoclide/coc.nvim"
      }}>{`CoC`}</a>{`.`}</p>
    <h1>{`What About CoC?`}</h1>
    <p>{`Wow, this one changes a lot since my `}<a parentName="p" {...{
        "href": "../2018-11-05-language-server-protocol"
      }}>{`last check`}</a>{`. Now it's very easy to use and a lot mature. Strongly recommend to people just from Visual Studio. It's a lot heavy as it looks like. It's an ambitious migration of VS extensions plus many powerful features. Major language as JS is a plus. If nvim-lsp fails me, I'll convert to CoC for sure.`}</p>
    <p>{`The reason to prefer nvim-lsp a bit is native support and performance, though right now, I have no evidence to show that. Another execuse is deoplete plugin doesn't work nicely with CoC and some of my plugins are with deoplete 😢.`}</p>
    <p>{`Anyway, now I could evaluate both of them in different projects in work and probably update later.`}</p>
    <h1>{`Nvim-LSP Setup in 3 Min`}</h1>
    <p>{`If setting up CoC is in 1 min, then lsp takes just a bit longer. To preview nvim's native lsp with me:`}</p>
    <ol>
      <li parentName="ol">{`Be sure to have `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`conda`}</code>{` at hand (you should!). If not please follow `}<a parentName="li" {...{
          "href": "https://github.com/daizeng1984/dotfiles/blob/master/installConda.sh#L16-L17"
        }}>{`this`}</a>{`. Just install nvim nightly build:`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`conda install -c daizeng1984/label/nightly nvim`}</code></pre></div>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">
        <p parentName="li">{`Comment out your old complete plugins like CoC, LanguageClient-neovim etc.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Install plugin `}<a parentName="p" {...{
            "href": "https://github.com/neovim/nvim-lsp"
          }}>{`nvim-lsp`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Add these lines to your config.vimrc:`}</p>
      </li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`lua <<EOF
require'nvim_lsp'.pyls.setup{}
require'nvim_lsp'.tsserver.setup{}
EOF`}</code></pre></div>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Then install language servers you need, for example `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`pyls`}</code>{` you can do: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`conda install -y -c conda-forge python-language-server`}</code>{` and for `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`tsserver`}</code>{` you can do in nvim directly `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:LspInstall tsserver`}</code>{`. For more language support, look at `}<a parentName="li" {...{
          "href": "https://github.com/neovim/nvim-lsp#user-content-configurations"
        }}>{`here`}</a>{`. Ideally, all these plugins should be installed with `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:LspInstall`}</code>{` seamlessly in nvim in the future just like CoC.`}</li>
    </ol>
    <h1>{`Java`}</h1>
    <p>{`Java is missing here. But again, just a `}<a parentName="p" {...{
        "href": "https://github.com/neovim/nvim-lsp/pull/245"
      }}>{`matter of time`}</a>{`.`}</p>
    <h1>{`Autocomplete`}</h1>
    <p>{`If you need autocomplete, add autocomplete plugin e.g. `}<a parentName="p" {...{
        "href": "https://github.com/Shougo/deoplete-lsp"
      }}>{`deoplete-lsp`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      